// Action Types
export const FETCH_CUSTOMERS_REQUEST = 'FETCH_CUSTOMERS_REQUEST';
export const FETCH_CUSTOMERS_SUCCESS = 'FETCH_CUSTOMERS_SUCCESS';
export const FETCH_CUSTOMERS_FAILURE = 'FETCH_CUSTOMERS_FAILURE';

export const CREATE_CUSTOMER_REQUEST = 'CREATE_CUSTOMER_REQUEST';
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS';
export const CREATE_CUSTOMER_FAILURE = 'CREATE_CUSTOMER_FAILURE';

export const UPDATE_CURRENT_PROJECT_ID = 'UPDATE_CURRENT_PROJECT_ID';




// Action Creators

export const fetchCustomersRequest = () => ({ type: FETCH_CUSTOMERS_REQUEST });
export const fetchCustomersSuccess = (data) => ({ type: FETCH_CUSTOMERS_SUCCESS, payload: data });
export const fetchCustomersFailure = (error) => ({ type: FETCH_CUSTOMERS_FAILURE, payload: error });

export const createCustomerRequest = (customer) => ({ type: CREATE_CUSTOMER_REQUEST, payload: customer });
export const createCustomerSuccess = (customer) => ({ type: CREATE_CUSTOMER_SUCCESS, payload: customer });
export const createCustomerFailure = (error) => ({ type: CREATE_CUSTOMER_FAILURE, payload: error });


export const updateCurrentProjectId = (projectId) => ({
    type: UPDATE_CURRENT_PROJECT_ID,
    payload: projectId,
  });
  




